import DOMPurify from 'dompurify'

/**
 * Sanitise an HTML string before rendering it through
 * dangerouslySetInnerHTML. Use ONLY when the source is trusted-but-not-static
 * (e.g. server-supplied marketing copy or terms blob). For user input,
 * always render via JSX children which auto-escape.
 *
 * ESLint forbids `dangerouslySetInnerHTML` in the codebase (react/no-danger),
 * so this helper is the controlled escape hatch - every call site needs an
 * inline override comment that explains why.
 */
export function sanitize(html: string): string {
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick'],
  })
}
